import fetchDealDetails from 'api/fetchDealDetails'
import fetchPartNumbers from 'api/fetchPartNumbers'
import findReps from 'api/findReps';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTotalCount, setDealDetails, setPartNo, setRep } from 'redux/modules/master/pipelinePartnumberMapper/slice';
import { getPipelinePartNumberMapper } from 'selectors';
import isEmptyArray from 'utils/isEmptyArray';

const usePipelineDistributorMapper = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [distPartNumbers, setDistPartNumbers] = useState([]);
  const [mfgPartNumbers, setMfgPartNumbers] = useState([]);
  const [zipMatch, setZipMatch] = useState('')

  const [partNumberLoading, setPartNumberLoading] = useState(false);
  const [reps, setReps] = useState([]);
  const state = useSelector(getPipelinePartNumberMapper);
  const { dealDetails, currentPage, pageSize, filter, rep, reset, partNo } = state;

  // const filter = useSelector(getFilter);

  const getList = () => {
    fetchDealDetails(currentPage, pageSize, filter).then((result) => {
      setLoading(false);
      if (result) {
        dispatch(setDealDetails({
          ...result,
          response: result.response.map(res => {
            const mfgpart = res.dealPartNumbers.filter(item => item.partNumberType === 'M');
            const dstpart = res.dealPartNumbers.filter(item => item.partNumberType === 'D');
            const status = res.dealPartNumbers.some(item => item.status === 'Good') ? 'Good' : 'Error'
            return ({
              ...res,
              mfgPartNo: mfgpart.map(item => item.partNumber),//.toString(),
              distrPartNo: dstpart.map(item => item.partNumber), //.toString(),
              status
            })
          })
        }));
        dispatch(setTotalCount(result.totalCount));

      }
    });
  };

  const getPartNumbers = () => {
    setPartNumberLoading(true);
    fetchPartNumbers(rep).then((result) => {
      dispatch(setPartNo(result))
      setPartNumberLoading(false);
    })
  }

  useEffect(() => {
    const fetchData = async () => {
      const reps = await findReps();
      setReps(reps);
      dispatch(setRep(reps[0]))
    }
    if (isEmptyArray(dealDetails)) {
      setLoading(true);
      if(rep) getPartNumbers();
      fetchData()
    }
  }, []);

  useEffect(() => {
    if (reset) {
      setLoading(true);
      getList();
    }
  }, [reset]);

  useEffect(() => {
    setLoading(true);
    getList();
  }, [filter,currentPage, pageSize]);

  useEffect(() => {
    if(rep) getPartNumbers();
  }, [rep]);

  const filterPartNumers = () => {
    console.log('zip change', zipMatch)
    let filteredPartNumers = [...partNo]
    if(zipMatch) {
      filteredPartNumers = partNo.filter(item => item.shipToZip === zipMatch)
    }
    setMfgPartNumbers(filteredPartNumers.map(item => item.mfgPartNo))
    setDistPartNumbers(filteredPartNumers.map(item => item.distrPartNo))
  }

  useEffect(() => {
    filterPartNumers();
  }, [zipMatch, partNo]);


  return [loading, reps, partNumberLoading, setZipMatch, zipMatch, mfgPartNumbers, distPartNumbers];
};

export default usePipelineDistributorMapper;
